import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Form } from 'app/models/form';

@Component({
  selector: 'app-form-dialog',
  templateUrl: './app-form-dialog.component.html',
  styleUrls: ['./app-form-dialog.component.scss']
})
export class AppFormDialogComponent implements OnInit {
  form: Form = null;

  constructor(
    public dialogRef: MatDialogRef<AppFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: Form,
  ) {
  }

  ngOnInit() {
    this.form = this.data;
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
